import React from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import PricingPage from './components/PricingPage';
import CheckoutPage from './components/CheckoutPage';
import SuccessPage from './components/SuccessPage';
import './App.css'; // Make sure this file exists
import Homepage_Header from './components/Homepage_Header';
import Homepage_HowItWorks from './components/Homepage_HowItWorks';
import Homepage_Services from './components/Homepage_Services';
import Homepage_Pricing from './components/Homepage_Pricing';
import Homepage_FAQ from './components/Homepage_FAQ';
import Homepage_Footer from './components/Homepage_Footer';
import { useEffect } from 'react';


function HomePage() {
  return (
    <div className="App">
      <Homepage_Header />
      <Homepage_HowItWorks />
      <Homepage_Services />
      <Homepage_Pricing />
      <Homepage_FAQ />
      <Homepage_Footer />
    </div>
  );
}

function App() {

   useEffect(() => {
    document.title = "ZapZappp"; // Change this to your desired title
  }, []); 
  return (
    <Router>
      <Switch>
        <Route exact path="/" component={HomePage} />
        <Route path="/pricing" component={PricingPage} />
        <Route path="/checkout" component={CheckoutPage} />
        <Route path="/success" component={SuccessPage} />
        {/* Add other routes as needed */}
      </Switch>
    </Router>
  );
}

export default App;
